<div class="contract-history-tab" data-testid="contract-history-tab">
    @if (loading) {
        <spinner></spinner>
    } @else if (loadError) {
        <div class="alert alert-warning" role="alert" data-testid="contract-history-error">{{ loadError }}</div>
    } @else if (events.length === 0) {
        <p class="text-muted" data-testid="contract-history-empty">No history yet</p>
    } @else {
        <div class="table-responsive">
            <table class="table table-sm align-middle" data-testid="contract-history-table">
                <caption class="visually-hidden">Deactivation and reactivation history of this contract</caption>
                <thead>
                    <tr>
                        <th scope="col">Change</th>
                        <th scope="col">Reason</th>
                        <th scope="col">Added on</th>
                    </tr>
                </thead>
                <tbody>
                    @for (event of events; track event.id) {
                        <tr data-testid="contract-history-row">
                            <td>{{ changeLabel(event) }}</td>
                            <td class="contract-history-reason">{{ event.reason?.trim() ? event.reason : 'N/A' }}</td>
                            <td>{{ event.createdAt | date: 'dd/MM/yyyy HH:mm' }}</td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
        @if (total > pageSize) {
            <ngb-pagination [collectionSize]="total" [pageSize]="pageSize" [page]="page"
                            (pageChange)="onPageChange($event)" [maxSize]="5" [boundaryLinks]="true"
                            aria-label="Contract history pages" data-testid="contract-history-pagination">
            </ngb-pagination>
        }
    }

    @if (canChangeState && (canDeactivate || canReactivate)) {
        <div class="contract-history-actions" [class.contract-history-actions-end]="!canDeactivate">
            @if (canDeactivate) {
                <button type="button" class="btn btn-gray text-dark" #stateButton
                        (click)="openDeactivateModal()"
                        data-testid="contract-deactivate">
                    <i class="bi bi-slash-circle me-2" aria-hidden="true"></i>Deactivate contract
                </button>
            } @else {
                <button type="button" class="btn btn-success" #stateButton
                        [disabled]="reactivating"
                        confirmHeader="Confirm the action"
                        confirmModal="Are you sure you want to reactivate this contract?"
                        confirmMessage=""
                        confirmOk="Yes, proceed"
                        confirmCancel="No, cancel"
                        confirmOkClass="btn-success"
                        confirmCancelClass="btn-gray text-dark"
                        [confirmCancelFirst]="true"
                        (confirmedClick)="reactivate()"
                        data-testid="contract-reactivate">
                    <i class="bi bi-arrow-counterclockwise me-2" aria-hidden="true"></i>Reactivate contract
                </button>
            }
        </div>
    }
</div>
